// extracted by mini-css-extract-plugin
export var actions = "_31-0";
export var actionsContainer = "_31-7";
export var border = "_31-1";
export var childFullHeight = "_31-f";
export var collapse = "_31-2";
export var content = "_31-a";
export var contentChild = "_31-e";
export var fullscreen = "_31-c";
export var hasLeftRadius = "_31-k";
export var headerContainer = "_31-3";
export var headerRow = "_31-5";
export var hidePadding = "_31-b";
export var navCollapsedGap = "_31-l";
export var noScrollX = "_31-m";
export var noScrollY = "_31-n";
export var noTopPadding = "_31-i";
export var optOutTopPadding = "_31-d";
export var pageMain = "_31-j";
export var pageOuter = "_31-g";
export var pagePadding = "_31-8";
export var pageScroll = "_31-9";
export var profile = "_31-o";
export var profileContainer = "_31-p";
export var profileImage = "_31-q";
export var profileMain = "_31-r";
export var profileSubtitle = "_31-t";
export var profileTitle = "_31-s";
export var showLeftPadding = "_31-h";
export var tabsPortalSlot = "_31-6";
export var tabsWrapper = "_31-4";
export var title = "_31-u";